export default "__VITE_ASSET__DT$AAX94__"